<template>
  <div class="overflow-x-auto rounded-md border border-gray-200 dark:border-gray-500">
    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-500 text-sm">
      <thead class="bg-gray-50 dark:bg-gray-700">
        <tr>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Ticket ID</th>
          <th
            class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100 cursor-pointer select-none"
            @click="$emit('sort', 'submitted')"
          >
            Submitted
            <span v-if="sortOrder === 'ASC'" class="ml-1 text-xs">▲</span>
            <span v-else-if="sortOrder === 'DESC'" class="ml-1 text-xs">▼</span>
          </th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Company</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Tech</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Status</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Type</th>
          <th class="px-3 py-2 text-left font-medium text-gray-700 dark:text-gray-100">Summary</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-gray-500 bg-white dark:bg-gray-700">
        <tr
          v-for="row in rows"
          :key="row.id"
          class="hover:bg-yellow-50 dark:hover:bg-gray-600 cursor-pointer"
          @click="$emit('open', row)"
        >
          <td class="px-3 py-2 whitespace-nowrap font-mono text-xs">
            <a
              href="#"
              @click.stop.prevent="$emit('openTicketV2', row.id)"
              class="text-blue-600 dark:text-blue-300 hover:underline"
            >{{ row.id }}</a>
          </td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ formatDate(row.submitted) }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ row.company_name || '—' }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ row.tech_name || '—' }}</td>
          <td class="px-3 py-2 whitespace-nowrap text-gray-800 dark:text-gray-100">{{ isOpen(row) ? 'Open' : 'Closed' }}</td>
          <td class="px-3 py-2 text-gray-800 dark:text-gray-100">{{ row.ticket_type_name || '—' }}</td>
          <td class="px-3 py-2 text-gray-800 dark:text-gray-100 max-w-md" :title="row.description">
            <div class="line-clamp-4" v-html="renderMarkdown(row.description, { compact: true, maxLines: 8 })"></div>
          </td>
        </tr>
        <tr v-if="!rows.length">
          <td colspan="7" class="px-3 py-6 text-center text-gray-500 dark:text-gray-300">No results.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { renderMarkdown } from '@/utils/markdown';
defineProps({
  rows: { type: Array, default: () => [] },
  sortOrder: { type: String, default: '' },
});
defineEmits(['open', 'openTicketV2', 'sort']);

function formatDate(d) {
  if (!d || String(d).startsWith('0000')) return '—';
  return String(d).substring(0, 10);
}
function isOpen(row) {
  return !row.completed || String(row.completed).startsWith('0000');
}
</script>
